module.exports = __webpack_public_path__ + "img/auditTrail_icon.57dcd6fd.svg";